

function CecopalLink() {

  return (
    <>
      <a
        href="https://cecopal.paterna.es/minute/create"
        rel="noopener noreferrer"
        className="link-cecopal"
        target="_blank"
      >
        Crear parte Cecopal
      </a>
      
    </>
  );
}

export default CecopalLink;
